import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';
import { PVBInfo } from '@core/model/PVBInfo.model';
import { VilaxInfo } from '@core/model/vilaxInfo.model';
import { DvhInfo } from '@core/model/dvhInfo.model';
import { PVBConfigInfo } from '@core/model/PvbConfigInfo.model';
import { ThrowStmt } from '@angular/compiler';
import { utiles } from '@utl/environment';
import { timeStamp } from 'console';
import { ModelInfo } from '@core/model/modelInfo.model';
import { SeparadorInfo } from '@core/model/separadorInfo.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-modal-config-pvb',
  templateUrl: './modal-config-pvb.component.html',
  styleUrls: ['./modal-config-pvb.component.scss']
})
export class ModalConfigPvbComponent implements OnInit {
  labelTitile: string;
  displayedColumns: string[] = ['Borrar', 'Tipo', 'Espesor', 'Acabado'];
  dataSourceCapas: any[] = [];
  Pvb: PVBInfo;
  Separador: SeparadorInfo;
  VilaxInfoModel: VilaxInfo;
  DVHInfoModel: DvhInfo;
  modelInfoModel: ModelInfo;
  numCapa: number;
  cmbTipoPvb: string;
  cmbEspesorPvb: string;
  cmbAcabadoPvb: string;
  PvbConfigInfo: PVBConfigInfo[] = [];
  cmbTipoList: PVBConfigInfo[] = [];
  cmbEspesorList: PVBConfigInfo[] = [];
  cmbAcabadoList: PVBConfigInfo[] = [];
  restringeCombina: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ModalConfigPvbComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMessage: any,
    ) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.modelInfoModel = this.dataMessage.modelInfoModel;
      this.numCapa = this.dataMessage.numCapa;
      this.PvbConfigInfo = this.dataMessage.PvbInfo;
      if (this.modelInfoModel.vModelo === 'VILAX') {
        this.VilaxInfoModel = this.modelInfoModel as VilaxInfo;
        this.VilaxInfoModel.vListaPVB.forEach(element => {
          if (element.vIdentificador === this.numCapa) {
            this.Pvb = element;
          }
        });
      } else if (this.modelInfoModel.vModelo === 'DVH') {
        this.DVHInfoModel = this.modelInfoModel as DvhInfo;
        this.DVHInfoModel.vListaSeparadores.forEach(element => {
          if (element.vIdentificador === this.numCapa) {
            this.Separador = element;
          }
        });
      }
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }
  }

  ngOnInit() {
    this.CargarCapas();
    this.loadCmboxType();
  }

  loadCmboxType() {
    const hash = {};
    let vTipoSelec = '';

    if (this.modelInfoModel.vModelo === 'VILAX') {
      if (this.Pvb.vListaPVB.length > 0) {
        vTipoSelec = this.Pvb.vListaPVB[0].vTipoPVB;
      } else {
        this.VilaxInfoModel.vListaPVB.forEach(element => {
          if (element.vTipoPVB !== '') {
            vTipoSelec = element.vTipoPVB;
          }
        });
      }
    }
    
    this.cmbTipoList = this.PvbConfigInfo.filter(function(current) {
      const exists = (!hash[current.Tipo] || false) && current.Tipo !== '' && current.Tipo !== undefined
      && ((vTipoSelec !== '' && current.Tipo === vTipoSelec) || vTipoSelec === '');
      hash[current.Tipo] = true;
      return exists;
    });
  }

  loadCmboxEsp() {
    const hash = {};
    const tipoPVB = this.cmbTipoPvb;
    const extModel = this.modelInfoModel.vModelo;
    let sumEsp = 0;
    let limitaCombina = this.restringeCombina;
    if (extModel === 'VILAX') {
      sumEsp = this.Pvb.vEspesor;
    }

    this.cmbEspesorList = this.PvbConfigInfo.filter(function(current) {
      const exists = (!hash[current.Espesor] || false) && current.Espesor !== '' && current.Espesor !== undefined
      && current.Tipo === tipoPVB
      && ((extModel === 'VILAX' && !limitaCombina && current.Espesor <= (1.52 - sumEsp).toString()) || (extModel === 'DVH'));
      hash[current.Espesor] = true;
      return exists;
    });
  }

  loadCmboxAcabado() {
    const hash = {};
    const tipoPVB = this.cmbTipoPvb;
    const EspesorPVB = this.cmbEspesorPvb;
    let limitaCombina = this.restringeCombina;
    let sumEsp = 0;
    if (this.modelInfoModel.vModelo === 'VILAX') {
      sumEsp = this.Pvb.vEspesor;
    }
    
    this.cmbAcabadoList = this.PvbConfigInfo.filter(function(current) {
      const exists = (!hash[current.Acabado] || false) && current.Acabado !== '' && current.Acabado !== undefined
      && current.Tipo === tipoPVB && current.Espesor === EspesorPVB.toString()
      && !limitaCombina && !(sumEsp > 0 && current.LimitaCombina);
      return exists;
    });
  }

  CargarCapas() {
    const Capas = [];
    let restringeComb = false;

    if (this.modelInfoModel.vModelo === 'VILAX') {
      this.Pvb.vListaPVB.forEach(PvbTmp => {
        if (PvbTmp.vLimitaCombina)
          restringeComb = true;

        Capas.push({Borrar: PvbTmp.vIdentificador, Tipo: PvbTmp.vTipoPVB, Espesor: PvbTmp.vEspesor,
        Acabado: PvbTmp.vColor});
      });
    } else if (this.modelInfoModel.vModelo === 'DVH') {
        Capas.push({Borrar: this.Separador.vIdentificador, Tipo: this.Separador.vTipo, Espesor: this.Separador.vEspesor,
        Acabado: this.Separador.vColor});
    }

    this.restringeCombina = restringeComb;
    this.dataSourceCapas = Capas;
  }

  DefineInfoPVBPrincipal() {
    let vEspesorTot = 0;
    let vAcabado = '';
    let vTipo = '';
    let vPvbCompuesto = false;

    this.Pvb.vListaPVB.forEach(element => {
      if (vTipo === '') {
        vTipo = element.vTipoPVB;
      }

      if(element.vCompuesto) {
        vPvbCompuesto = true;
      }

      vEspesorTot += element.vEspesor;

      if (vAcabado === '') {
        vAcabado = element.vColor;
      } else if (vAcabado !== element.vColor) {
        vAcabado = 'Compuesto';
      }
    });

    this.Pvb.vTipoPVB = vTipo;
    this.Pvb.vEspesor = +vEspesorTot.toFixed(2);
    this.Pvb.vColor = vAcabado;
    this.Pvb.vCompuesto = vPvbCompuesto;
  }

  AddCapa() {
    if (this.cmbTipoPvb !== undefined && this.cmbEspesorPvb !== undefined && this.cmbAcabadoPvb !== undefined) {
      if (this.modelInfoModel.vModelo === 'VILAX') {
          const pvbTmp = new PVBInfo();
          pvbTmp.vIdentificador = this.Pvb.vListaPVB.length + 1;
          pvbTmp.vTipoPVB = this.cmbTipoPvb;
          pvbTmp.vEspesor = +this.cmbEspesorPvb;
          pvbTmp.vColor = this.cmbAcabadoPvb;
          this.PvbConfigInfo.forEach(PvbVar => {
            if (PvbVar.Tipo === this.cmbTipoPvb
            && PvbVar.Espesor === this.cmbEspesorPvb
            && PvbVar.Acabado === this.cmbAcabadoPvb) {
              pvbTmp.vCompuesto = PvbVar.Compuesto;
              pvbTmp.vLimitaCombina = PvbVar.LimitaCombina;
            }
          });
          this.Pvb.vListaPVB.push(pvbTmp);
          this.DefineInfoPVBPrincipal();
          if (+this.cmbEspesorPvb > (1.52 - this.Pvb.vEspesor)) {
            this.cmbEspesorPvb = '';
            this.cmbAcabadoPvb = '';
          }
      } else if (this.modelInfoModel.vModelo === 'DVH') {
        this.Separador.vTipo = this.cmbTipoPvb;
        this.Separador.vEspesor = +this.cmbEspesorPvb;
        this.Separador.vColor = this.cmbAcabadoPvb;
      }
    }

    this.CargarCapas();
    this.loadCmboxType();
    this.loadCmboxEsp();
    this.loadCmboxAcabado();
  }

  reordenarCapasPVB() {
    let i = 0;

    if (this.modelInfoModel.vModelo === 'VILAX') {
      this.Pvb.vListaPVB.forEach(PvbTmp => {
        i++;
        PvbTmp.vIdentificador = i;
      });
    }

    this.CargarCapas();
  }

  DeleteCapa(numCapa: number) {
    if (this.modelInfoModel.vModelo === 'VILAX') {
      if (this.Pvb.vListaPVB.length >= numCapa) {
        const ListaTmp: PVBInfo[] = [];
        this.Pvb.vListaPVB.forEach(PvbTmp => {
          if (PvbTmp.vIdentificador !== numCapa) {
            ListaTmp.push(PvbTmp);
          }
        });

        this.Pvb.vListaPVB = ListaTmp;
      }
      this.DefineInfoPVBPrincipal();
    } else if (this.modelInfoModel.vModelo === 'DVH') {
      this.Separador.vTipo = '';
      this.Separador.vEspesor = 0;
      this.Separador.vColor = '';
    }

    this.reordenarCapasPVB();
    this.loadCmboxType();
    this.loadCmboxEsp();
    this.loadCmboxAcabado();
  }

  PermiteAgregarCapas() {
    let ret = true;
    if (this.cmbTipoPvb === undefined || this.cmbEspesorPvb === undefined || this.cmbAcabadoPvb === undefined) {
      ret = false;
    }
    if (ret === true && this.modelInfoModel.vModelo === 'VILAX') {
      if (this.Pvb.vEspesor >= 1.52) {
        ret = false;
      }
    } else if (ret === true && this.modelInfoModel.vModelo === 'DVH') {
      if (this.Separador.vColor !== '') {
        ret = false;
      }
    }
    if(this.restringeCombina)
      ret = false;

    return ret;
  }

  close() {
    utiles.clearCacheVilaxInfo();
    utiles.createCacheVilaxInfo(this.VilaxInfoModel);
    this.dialogRef.close();
  }
}
